import { Injectable } from '@angular/core';
import { Environment } from 'src/environments/environment.class';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
  providedIn: 'root',
})
export class UrlUtilService {
  constructor(
    private readonly environment: Environment,
    private readonly configurationService: ConfigurationService
  ) {}

  getChangementAdresseAccesDUrl(endpoint: string): string {
    const baseUrlSICaad = this.environment.mock
      ? this.environment.mockDomaine
      : this.configurationService.getValueOrBlank(configuration.ConfigMeta.OEL_PAAS_API_URL);
    const paasApiCheminBase = `${this.configurationService.getValueOrBlank('paas-api-chemin-base')}`;
    return baseUrlSICaad + paasApiCheminBase + endpoint;
  }
}
